import React, { useEffect, useState } from "react";
import Footer from "../Footer/Main";
import MenuList1Bred from "../BredCrumb/MenuList1Bred";
import Header from "../Header/Main";
import Aos from "aos";
import {
  getAllCategories,
  getAllProductsByCategory,
} from "../../services/products";
import Loader from "../Loader/Loader";
import OfferMenu2 from "../MenMenuList/OfferMenu2";
import { Link } from "react-router-dom";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function findParentCategories(categories) {
  const parentCategoryIds = new Set();
  categories.forEach((category) => {
    if (category.isSeparate) {
      parentCategoryIds.add(category._id);
    }
  });
  return categories
    .filter((category) => parentCategoryIds.has(category._id))
    .sort((a, b) => a.order - b.order);
}

function findProductsByParentCategory(data, parentCategoryId = null) {
  const filteredCategories = data.filter((category) => {
    if (parentCategoryId) {
      return category.categoryDetails.parentCategory === parentCategoryId;
    } else {
      return !category.categoryDetails.parentCategory;
    }
  });

  return filteredCategories.map((category) => ({
    categoryDetails: category.categoryDetails,
    products: category.products,
  }));
}

function getAllSpecialItems(data) {
  let specials = [];
  data?.forEach((item) =>
    item?.products?.forEach((prod) => {
      if (prod?.isSpecial) {
        specials = [...specials, prod];
      }
    })
  );

  return specials;
}

function Main() {
  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);
  const [numPages, setNumPages] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [productsByCategory, setProductsByCategory] = useState([]);
  const [sideBarCategories, setSideBarCategories] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(0);
  const [specialProducts, setSpecialProducts] = useState([]);
  const [pdfValue, setPdfValue] = useState(undefined);

  useEffect(() => {
    const fetchAndStoreData = async () => {
      setIsLoading(true);
      try {
        const localCategories = localStorage.getItem("categories");
        const localProductsByCategory =
          localStorage.getItem("productsByCategory");

        if (localCategories && localProductsByCategory) {
          const categoriesData = JSON.parse(localCategories);
          const productsByCategoryData = JSON.parse(localProductsByCategory);

          processData(categoriesData, productsByCategoryData);
          fetchDataFromAPI();
        } else {
          await fetchDataFromAPI();
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchDataFromAPI = async () => {
      const [categoriesRes, productsByCategoryRes] = await Promise.all([
        getAllCategories(),
        getAllProductsByCategory(),
      ]);

      const categoriesData = categoriesRes.data?.categories || [];
      const productsByCategoryData = productsByCategoryRes.data || [];

      localStorage.setItem("categories", JSON.stringify(categoriesData));
      localStorage.setItem(
        "productsByCategory",
        JSON.stringify(productsByCategoryData)
      );

      processData(categoriesData, productsByCategoryData);
    };

    const processData = (categoriesData, productsByCategoryData) => {
      const foundCategories = findParentCategories(categoriesData);

      setSpecialProducts(getAllSpecialItems(productsByCategoryData));
      setCategories(categoriesData);
      setProductsByCategory(productsByCategoryData);
      setSideBarCategories(foundCategories);
      setRelatedProducts(
        findProductsByParentCategory(
          productsByCategoryData,
          foundCategories?.[0]?._id
        )
      );
      setSelectedCategoryId(foundCategories?.[0]?._id);
    };

    fetchAndStoreData();
  }, []);

  const scrollToDishList = (category) => {
    const item = categories.find((item) => item?._id === category);
    if (item?.pdf) {
      setPdfValue(item?.pdf);
    } else if (item?.isSeparate) {
      setPdfValue(undefined);
      const categoriesFound = findProductsByParentCategory(
        productsByCategory,
        category
      );
      setSelectedCategoryId(categoriesFound?.[0]?._id);
      setRelatedProducts(categoriesFound);
    } else {
      setPdfValue(undefined);
      const categoriesFound = findProductsByParentCategory(productsByCategory);
      setSelectedCategoryId(categoriesFound?.[0]?._id);
      setRelatedProducts(categoriesFound);
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className="page_wrapper">
      <Loader isLoading={isLoading} />
      <Header />

      {specialProducts?.length ? (
        <MenuList1Bred specialProducts={specialProducts} />
      ) : (
        <></>
      )}
      <section
        className="row_am offer_menu_section"
        style={{
          marginBottom: 0,
          ...(specialProducts?.length > 0 ? { marginTop: 0 } : {}),
        }}
      >
        <div className="container" style={{ padding: 0 }}>
          <ul
            className={`nav nav-tabs`}
            id="myTab"
            role="tablist"
            data-aos="fade-up"
            data-aos-duration={1500}
            style={{
              marginBottom: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                overflowX: "scroll",
                whiteSpace: "nowrap",
                padding: 0,
                WebkitOverflowScrolling: "touch",
                overflowY: "hidden",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {sideBarCategories?.map((categoryDetails, index) => (
                <li
                  className="nav-item"
                  key={categoryDetails?._id}
                  style={{
                    marginRight: "10px",
                    display: "flex",
                  }}
                >
                  <Link
                    className={`nav-link ${
                      categoryDetails?._id === selectedCategoryId
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      scrollToDishList(categoryDetails?._id);
                    }}
                    id="lunch-tab"
                    data-toggle="tab"
                    to="#lunch"
                    role="tab"
                    aria-controls="lunch"
                    aria-selected="true"
                  >
                    {categoryDetails.name}
                  </Link>
                  {index !== sideBarCategories?.length - 1 && (
                    <h2
                      style={{
                        marginLeft: "14px",
                        color: "#9a9a9a",
                      }}
                    >
                      |
                    </h2>
                  )}
                </li>
              ))}
            </div>
          </ul>
        </div>
      </section>
      <h1>{!!pdfValue}</h1>
      {pdfValue ? (
        <Document
          file={pdfValue}
          onLoadSuccess={onDocumentLoadSuccess}
          onError={(error) => console.log("error loading pdf:", error)}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              style={{ width: 100, height: 100, backgroundColor: "red" }}
              renderAnnotationLayer={false}
              renderTextLayer={false}
              wrap
            />
          ))}
        </Document>
      ) : (
        <OfferMenu2
          relatedProducts={relatedProducts}
          categories={categories?.data?.categories}
        />
      )}
      <Footer />
    </div>
  );
}

export default Main;

